import {
  ENTITY_TYPE_IDS,
  S_CORP_ENTITY_TYPE_NAMES,
  S_CORP_LABEL_SUFFIX,
  TAXED_AS,
  TaxedAs,
} from "v2/constants/entityTypes";

export type MainEntity = "corp" | "llc" | "nonprofit" | "sole";

export const MAIN_ENTITY_OPTIONS: {
  key: MainEntity;
  name: string;
  desc: string;
}[] = [
  {
    key: "corp",
    name: "Corporation",
    desc: "US - incorporated Corporations",
  },
  {
    key: "llc",
    name: "LLC",
    desc: "Flexible structure; we'll ask about tax treatment next",
  },
  {
    key: "nonprofit",
    name: "Non-profit 501(c)(3)",
    desc: "Tax-exempt charitable, educational, or religious org",
  },
  {
    key: "sole",
    name: "Sole Proprietorship",
    desc: "Unincorporated business owned and run by one individual",
  },
];

export const LLC_TAX_OPTIONS: { key: TaxedAs; name: string; desc: string }[] = [
  {
    key: TAXED_AS.SINGLE_MEMBER,
    name: "Single member",
    desc: "One owner, taxed as a disregarded entity",
  },
  {
    key: TAXED_AS.C_CORP,
    name: "Taxed as C Corp",
    desc: "You LLC has formally elected C Corporation tax treatment",
  },
  {
    key: TAXED_AS.PARTNERSHIP,
    name: "Partnership",
    desc: "Two or more owners, taxed as a partnership",
  },
  {
    key: TAXED_AS.S_CORP,
    name: "Taxed as S Corp",
    desc: "Your LLC has formally elected S Corporation tax treatment",
  },
];

export type EntityResolution = {
  entityTypeId: string;
  label: string;
  taxedAs?: TaxedAs;
};

/**
 * Resolve the user's selection into the backend entity-type id to persist and
 * the label to show. Returns null when the selection is incomplete.
 */
export const resolveEntity = (
  main: MainEntity | null,
  taxedAs: TaxedAs | null
): EntityResolution | null => {
  if (!main) return null;

  if (main === "corp") {
    if (taxedAs === TAXED_AS.S_CORP) {
      return {
        entityTypeId: ENTITY_TYPE_IDS.ccorp,
        label: `${S_CORP_ENTITY_TYPE_NAMES.corporation} ${S_CORP_LABEL_SUFFIX}`,
        taxedAs: TAXED_AS.S_CORP,
      };
    }
    return {
      entityTypeId: ENTITY_TYPE_IDS.ccorp,
      label: "Corporation (C-Corp)",
    };
  }

  if (main === "nonprofit") {
    return {
      entityTypeId: ENTITY_TYPE_IDS.nonprofit,
      label: "Non-profit 501(c)(3)",
    };
  }

  if (main === "sole") {
    return {
      entityTypeId: ENTITY_TYPE_IDS.soleprop,
      label: "Sole Proprietorship",
    };
  }

  // LLC — tax treatment required.
  if (!taxedAs) return null;

  return {
    entityTypeId: ENTITY_TYPE_IDS.llc,
    label: "LLC",
    taxedAs,
  };
};
